import { Component, OnInit } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { ActivatedRoute, Router } from "@angular/router";
import 'rxjs/add/operator/filter';
import { InicioService } from './inicio/inicio/inicio.service';
import { usuario } from './inicio/inicio/models/usuario';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [InicioService],
})
export class AppComponent implements OnInit {

  title = 'Emisión web';
  token ;
  displayOpcionesMenu = false;

  constructor(
   
  ) { }

  ngOnInit(): void {
   
  }

}
